import ClickAwayListener from "@components/Layout/ClickAwayListener";
import { AircallContext } from "@context/aircallProvider";
import Dropdown from "@salesforce/design-system-react/components/menu-dropdown";
import Icon from "@salesforce/design-system-react/components/icon";

import React, { useContext, useState } from "react";
import { KrispcallContext } from "@context/krispcallProvider";
import cx from "classnames";
import "./style.scss";

const VoicecallDropdown = (): JSX.Element => {
	const [isOpen, setIsOpen] = useState(false);
	const closeDropdown = (): void => setIsOpen(false);
	const krispcallContext = useContext(KrispcallContext);
	const aircallContext = useContext(AircallContext);

	if (!krispcallContext || !aircallContext) return <React.Fragment />;

	const {
		checkKrispcallProceed,
		krispcallClose,
		krispcallOpen,
		isKrispcallShown,
	} = krispcallContext;
	const { checkProceed, aircallOpen, isAircallShown, aircallClose } =
		aircallContext;

	const toggleDropdown = (): void => {
		setIsOpen(st => !st);
	};

	const handleAircallClick = (): void => {
		if (isKrispcallShown) {
			krispcallClose();
		}
		const proceed = checkProceed("", false);
		if (proceed) aircallOpen();
	};

	const handleKrispcallClick = (): void => {
		if (isAircallShown) {
			aircallClose();
		}
		const proceed = checkKrispcallProceed("", false);
		if (proceed) krispcallOpen();
	};
	return (
		<li className="pc-navigation-bar-dropdown-list pc-settings-popover voicecall-container">
			<ClickAwayListener onClickAway={(): void => closeDropdown()}>
				<button
					className={cx("voicecall", {
						"aircall-border": isAircallShown,
						"krispcall-border": isKrispcallShown,
					})}
					onClick={toggleDropdown}
					type="button"
				>
					<Icon
						category="custom"
						name={
							isAircallShown
								? "pc-aircall"
								: isKrispcallShown
								? "pc-krispcall"
								: "pc-call"
						}
						size="small"
						className="voicecall-icon"
					/>
					<Dropdown
						iconCategory="utility"
						iconName="chevrondown"
						iconPosition="right"
						label="Call"
						triggerClassName="voivcecall-dropdown-trigger"
						options={[
							{
								label: "Call with Aircall",
								leftIcon: {
									category: "custom",
									name: "pc-aircall",
									size: "small",
								},
								provider: "AIRCALL",
							},
							{
								label: "Call with KrispCall",
								leftIcon: {
									category: "custom",
									name: "pc-krispcall",
									size: "small",
								},
								provider: "KRISPCALL",
							},
						]}
						isOpen={isOpen}
						onSelect={(item: {
							label: string;
							leftIcon: object;
							provider: string;
						}): void => {
							closeDropdown();
							if (item.provider === "AIRCALL") {
								handleAircallClick();
							} else {
								handleKrispcallClick();
							}
						}}
					/>
				</button>
			</ClickAwayListener>
		</li>
	);
};

export default VoicecallDropdown;
